import isEmpty from 'lodash/isEmpty'
/** 格式化水镜展示位置树形选择列表数据 */
export function formatShuijingCatalogList(dataSource) {
  if (isEmpty(dataSource)) {
    return []
  }
  return dataSource.map(item => {
    const result = {}
    result.value = item.id
    result.title = item.title
    result.key = item.id
    if (item.child_general_modules && item.child_general_modules.length > 0) {
      result.disabled = true
      result.children = formatShuijingCatalogList(item.child_general_modules)
    }
    return result
  })
}
